export default __webpack_public_path__ + "images/923117a6693cdb895fdb97f5a73ac652-drawingandpainting_small.webp";